
import { RadioGroup } from 'element-ui'

export default {
  extends: RadioGroup,
}
